<nf-grid-wrapper>
  <ng-grid-wrapper-header-right>
    <nf-search placeholder="Search List..." [formControl]="search"> </nf-search>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content
    ><nf-table-layout
      [hideTitle]="true"
      [gridOptions]="gridOptions"
      [modules]="gridModules"
      [autoResizeGrid]="false"
      [data]="commands"
      hideSearch
      hideClearAll
      *nfLoader="isLoading"
    >
    </nf-table-layout
  ></nf-grid-wrapper-content>
</nf-grid-wrapper>
